import React from 'react';
import virtualScroll from '../../dispatcher/hoc/virtualScroll';

import NavigationBaseEditorGrid from './NavigationBaseEditorGrid';

class NavigationEditorGrid extends NavigationBaseEditorGrid {}

export default virtualScroll(NavigationEditorGrid, true);
